import { Button, Typography } from '@mui/material'
import FullPageLayout from 'components/FullPageLayout/FullPageLayout'
import { useTranslation } from 'react-i18next'
import OrderwireLogo from 'views/CreateCompany/components/OrderwireLogo'
import ContactSupportButton from 'pages/LicenseErrorPage/ContactSupportButton'

interface Props {
    message: string
}

function ErrorPage({ message = '' }: Props) {
    const { t } = useTranslation()

    return (
        <FullPageLayout>
            <>
                <OrderwireLogo />
                <Typography variant="h5" style={{ marginTop: 16 }}>
                    {t('error_page.title')}
                </Typography>
                {message && (
                    <Typography style={{ marginTop: 8 }} color="text.secondary">
                        {message}
                    </Typography>
                )}
                <div style={{ marginTop: 24 }}>
                    <Button
                        color="info"
                        variant="contained"
                        onClick={() => window.location.reload()}
                    >
                        {t('error_page.button.retry')}
                    </Button>
                    <ContactSupportButton style={{ marginLeft: 8 }} />
                </div>
            </>
        </FullPageLayout>
    )
}

export default ErrorPage
